"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ClusterBlue = function ClusterBlue(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Clustering_blau"), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "11.93",
    r: "6.65",
    style: {
      fill: '#054966'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,20.52a8.59,8.59,0,0,1-6.5-3,.5.5,0,1,1,.76-.66,7.58,7.58,0,0,0,11.48,0,.51.51,0,1,1,.77.66A8.59,8.59,0,0,1,12,20.52Z",
    style: {
      fill: '#054966',
      opacity: '0.9'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.64,15.11l-.17,0a.51.51,0,0,1-.31-.64,7.59,7.59,0,0,0-5.72-9.95.5.5,0,0,1,.19-1,8.6,8.6,0,0,1,6.49,11.27A.51.51,0,0,1,19.64,15.11Z",
    style: {
      fill: '#054966',
      opacity: '0.9'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.37,15.12a.5.5,0,0,1-.48-.34A8.6,8.6,0,0,1,10.43,3.48a.51.51,0,0,1,.18,1,7.59,7.59,0,0,0-5.77,10,.5.5,0,0,1-.31.64A.5.5,0,0,1,4.37,15.12Z",
    style: {
      fill: '#054966',
      opacity: '0.9'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,22.18a10.25,10.25,0,0,1-7.75-3.55A.51.51,0,0,1,5,18a9.24,9.24,0,0,0,14,0,.5.5,0,1,1,.77.66A10.25,10.25,0,0,1,12,22.18Z",
    style: {
      fill: '#054966',
      opacity: '0.8'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.2,15.65l-.17,0a.51.51,0,0,1-.31-.64,9.25,9.25,0,0,0-7-12.13.5.5,0,1,1,.19-1,10.26,10.26,0,0,1,7.74,13.45A.51.51,0,0,1,21.2,15.65Z",
    style: {
      fill: '#054966',
      opacity: '0.8'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.8,15.66a.51.51,0,0,1-.48-.34,10.26,10.26,0,0,1,7.8-13.47.51.51,0,0,1,.18,1A9.25,9.25,0,0,0,3.28,15a.51.51,0,0,1-.31.64A.5.5,0,0,1,2.8,15.66Z",
    style: {
      fill: '#054966',
      opacity: '0.8'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.35,16.16a.51.51,0,0,1-.48-.34A11.8,11.8,0,0,1,9.84.35a.51.51,0,0,1,.18,1A10.79,10.79,0,0,0,1.83,15.49a.51.51,0,0,1-.31.64Z",
    style: {
      fill: '#054966',
      opacity: '0.7000000000000001'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,23.72a11.78,11.78,0,0,1-8.92-4.08A.51.51,0,1,1,3.85,19a10.77,10.77,0,0,0,16.32,0,.5.5,0,1,1,.77.66A11.78,11.78,0,0,1,12,23.72Z",
    style: {
      fill: '#054966',
      opacity: '0.7000000000000001'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.65,16.16l-.17,0a.51.51,0,0,1-.31-.64A10.78,10.78,0,0,0,14,1.35a.51.51,0,1,1,.19-1,11.8,11.8,0,0,1,8.9,15.46A.51.51,0,0,1,22.65,16.16Z",
    style: {
      fill: '#054966',
      opacity: '0.7000000000000001'
    }
  }));
};

var _default = ClusterBlue;
exports["default"] = _default;